import { motion } from "framer-motion";
import { MapPin, Car } from "lucide-react";
import { useI18n } from "@/context/LanguageContext";

export const KeyInfo = () => {
  const { content, t } = useI18n();
  const i = t.info;
  const location = content.location;
  return (
    <section id="informacio" data-testid="info-section" className="bg-[#7AD5DC] py-16 md:py-36 border-y-2 border-[#141518]">
      <div className="max-w-[1400px] mx-auto px-4 md:px-8">
        <div className="grid grid-cols-12 gap-8 md:gap-16">
          <div className="col-span-12 lg:col-span-5">
            <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.7 }}>
              <div className="font-condensed font-bold uppercase tracking-[0.25em] text-sm md:text-base text-[#F0311B]">{i.eyebrow}</div>
              <h2 className="mt-4 font-display font-bold text-[13vw] sm:text-6xl md:text-7xl leading-[0.9] text-[#141518]">
                {i.titleA} <br />
                <span className="italic">{i.titleB}</span>
              </h2>
              <p className="mt-6 text-[#141518]/75 max-w-md leading-relaxed">{i.intro}</p>

              <div className="mt-10 space-y-6">
                <div data-testid="info-date" className="flex flex-col sm:flex-row sm:items-start gap-1 sm:gap-4">
                  <div className="font-condensed uppercase tracking-[0.2em] text-[10px] text-[#141518]/70 sm:w-20 sm:pt-1">{i.lblDate}</div>
                  <div>
                    <div className="font-display font-bold text-2xl md:text-3xl text-[#141518]">{i.dateBig}</div>
                    <div className="text-sm text-[#141518]/70">{i.dateSub}</div>
                  </div>
                </div>
                <div data-testid="info-place" className="flex flex-col sm:flex-row sm:items-start gap-1 sm:gap-4">
                  <div className="font-condensed uppercase tracking-[0.2em] text-[10px] text-[#141518]/70 sm:w-20 sm:pt-1">{i.lblPlace}</div>
                  <div>
                    <div className="font-display font-bold text-2xl md:text-3xl text-[#141518]">{location.name}</div>
                    <div className="text-sm text-[#141518]/70">{location.address}</div>
                  </div>
                </div>
                <div data-testid="info-parking" className="flex flex-col sm:flex-row sm:items-start gap-1 sm:gap-4">
                  <div className="font-condensed uppercase tracking-[0.2em] text-[10px] text-[#141518]/70 sm:w-20 sm:pt-1">{i.lblParking}</div>
                  <div className="flex items-start gap-2">
                    <Car size={18} className="text-[#F0311B] mt-1 flex-shrink-0" />
                    <p className="text-sm md:text-base text-[#141518] max-w-sm">{location.parking}</p>
                  </div>
                </div>
              </div>

              <a href={location.link} target="_blank" rel="noopener noreferrer" data-testid="info-map-button" className="mt-10 inline-flex items-center justify-center gap-3 bg-[#141518] text-white w-full sm:w-auto px-6 py-4 text-xs uppercase tracking-[0.22em] md:tracking-[0.25em] font-bold border-2 border-[#141518] shadow-hard hover:translate-x-[2px] hover:translate-y-[2px] hover:shadow-hard-sm transition-all">
                <MapPin size={16} />
                {i.cta}
                <span className="inline-block transition-transform group-hover:translate-x-1">→</span>
              </a>
            </motion.div>
          </div>

          <div className="col-span-12 lg:col-span-7">
            <motion.a href={location.link} target="_blank" rel="noopener noreferrer" initial={{ opacity: 0, scale: 0.97 }} whileInView={{ opacity: 1, scale: 1 }} viewport={{ once: true }} transition={{ duration: 0.8 }} data-testid="info-map-image" className="img-card block relative aspect-[4/5] md:aspect-square w-full bg-[#141518] border-[3px] border-[#141518] shadow-hard-lg overflow-hidden">
              <img src={location.image} alt={location.name} className="w-full h-full object-cover" loading="lazy" />
              <div className="absolute bottom-4 left-4 right-4 flex items-center justify-between bg-[#FFF7F1] px-4 py-3 border border-[#141518]">
                <div>
                  <div className="font-condensed uppercase tracking-[0.2em] text-[10px] text-[#F0311B]">{i.mapLabel}</div>
                  <div className="font-display text-xl">{location.name}</div>
                </div>
                <MapPin size={22} />
              </div>
            </motion.a>
          </div>
        </div>
      </div>
    </section>
  );
};
